const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3/",
  apiKey: "7c76582c6e57abe7ce73dfd604e5749e",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;
